<!-- 摄像头 -->
<template>
  <div>
    <el-row :gutter="12">
      <el-col v-for="(url,index) in urls" :key="index" :span="6" class="camera">
        <iframe :src="url" width="100%" height="250" />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { GetYsyPlayUrl } from '@/api/Universal'
export default {
  components: {},
  props: {
    datas: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      urls: []
    }
  },
  mounted () {

  },
  methods: {
    // 初始化摄像头
    initCamera () {
      for (const o of this.datas) {
        GetYsyPlayUrl({
          sn: o.gatewaysn,
          ishd: '0'
        }).then(res => {
          if (this.urls) {
            this.urls = []
          }
          this.urls.push(res.data)
        })
      }
    },
  }
}
</script>
<style lang='stylus' scoped>
.camera
 margin-bottom 10px
</style>

